/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digest_Turn_OffInputs */

const en_digest_turn_off = /** @type {(inputs: Digest_Turn_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop the Monday digest`)
};

/**
* | output |
* | --- |
* | "Stop the Monday digest" |
*
* @param {Digest_Turn_OffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const digest_turn_off = /** @type {((inputs?: Digest_Turn_OffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digest_Turn_OffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_digest_turn_off(inputs)
});